import { createSlice } from "@reduxjs/toolkit";
import { getCusineMasterAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getCusineMasterSlice = createSlice({
  name: "getCusineMaster",
  initialState: data,
  reducers: {
    getCusineMasterSlice(state) {
      state.isLoading = true;
    },
    getCusineMasterSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCusineMasterSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCusineMasterSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCusineMasterHandler: any = () => async (dispatch: any) => {
  try {
    dispatch(getCusineMasterAction.getCusineMasterSlice());
    const response: any = await getCusineMasterAPI();

    dispatch(getCusineMasterAction.getCusineMasterSliceSuccess(response));
  } catch (e: any) {
    dispatch(
      getCusineMasterAction.getCusineMasterSliceFailure(e?.response?.data)
    );
  }
};
export default getCusineMasterSlice.reducer;
export const getCusineMasterAction = getCusineMasterSlice.actions;
